import React, { ComponentType, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import type { State } from '../state/state';
import { CustomerType } from '../../types/page';

interface WithAuthProps {
    customer?: CustomerType;
    isAuthenticated?: boolean;
    location?: {};
}
// 646a0ebeffb5eb7319b989fe/

type WrapperProps = React.FC<WithAuthProps & {
    isProtectedRoute: boolean;
    WrappedComponent: ComponentType<any>
}>

// our render function
const Wrapper: WrapperProps = function Wrapper({
    customer, 
    isAuthenticated, 
    location, 
    isProtectedRoute, 
    WrappedComponent, 
    ...props
}) {            
    const goToHome = useMemo(() => {
        return !!(customer && (isAuthenticated && !isProtectedRoute));
    }, [customer, isAuthenticated, isProtectedRoute]);

    const goToLogin = useMemo(() => {
        return !isAuthenticated && isProtectedRoute;
    }, [isAuthenticated, isProtectedRoute]);

    if (goToHome) {
        return (
            <Redirect to={{pathname: '/home', state: { from: location }}} /> 
        )
    }
    
    if (goToLogin) {
        return (
            <Redirect to={{pathname: '/login', state: { from: location }}} /> 
        );
    }

    return <WrappedComponent 
        customer={customer} 
        isAuthenticated={isAuthenticated} 
        location={location} 
        {...props} 
    />
};

/**
 * withAuth function component accepts generic type T on the condition that they have all the required properties on the WithAuthProps type.
 * This means that any component that gets returned from "withAuth" can have props of any type but the component must also have the required properties on the WithAuthProps type
 * WrappedComponent: ComponentType<T> -> ComponentType<T> where "ComponentType" is a way of typing components where the component can accept X number of props -- in this case, prop "T"
 */
export default function withAuth<T extends WithAuthProps>(
    WrappedComponent: ComponentType<T>, 
    isProtectedRoute: boolean,
) { 
    function mapStateToProps(state: State) {        
		return {
			isAuthenticated: state.oauth.isAuthenticated,
			initialized: state.oauth.initialized,
			customer: state.oauth.customer,
			WrappedComponent,
            location: {},
			isProtectedRoute,
		};
	}
	return connect(mapStateToProps)(Wrapper);
}  